module.exports = __webpack_public_path__ + "img/ico_bofang.1540216f.svg";